<div class="tw-w-full tw-h-full tw-max-h-[100vh] tw-overflow-auto tw-p-5">
  <app-menu-mobile></app-menu-mobile>
  <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-xl tw-text-secondary tw-mb-5">{{ "settings" | translate }}</p>

  <form *ngIf="formGroup" class="tw-w-full tw-h-fit tw-relative" [formGroup]="formGroup">
    <div *ngIf="isFormChanged" class="tw-w-fit tw-h-fit tw-fixed tw-z-50 tw-right-10">
      <app-button [text]="'save-changes' | translate" [fullWidth]="false" [onButtonClick]="saveChanges.bind(this)"></app-button>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "business" | translate }}</p>
      <div class="tw-w-fit tw-min-w-72 tw-h-fit">
        <app-input [formGroup]="formGroup" formControlName="display_name" [label]="'business-display-name' | translate" [widthLimited]="true"></app-input>
        <app-input [formGroup]="formGroup" formControlName="name" [label]="'business-name' | translate" [widthLimited]="true"></app-input>
        <app-input [disabled]="true" [formGroup]="formGroup" formControlName="email" [label]="'email' | translate" [widthLimited]="true"></app-input>
      </div>

      <app-image-picker [formGroup]="formGroup" formControlName="file" imageFormControlName="imageURL" [label]="'upload-new-logo' | translate"></app-image-picker>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "banners" | translate }}</p>

      <div *ngIf="banners.length < maxBanners" class="tw-w-fit tw-h-fit tw-flex tw-items-center tw-mb-2">
        <div (click)="!bannerUploading && bannerFileInput.click()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-[5px] tw-cursor-pointer tw-p-2">
          <input #bannerFileInput type="file" class="tw-hidden" (change)="onBannerFileSelected($event)" accept="image/*" />
          <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/image-upload-icon.svg" />
        </div>
        <p class="tw-w-fit tw-h-full tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-pl-2">{{ "upload-new-banner" | translate }} ({{ banners.length }}/{{ maxBanners }})</p>
      </div>

      <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-3">
        <div *ngFor="let banner of banners" class="tw-w-48 tw-h-24 tw-relative tw-flex tw-justify-center tw-items-center tw-bg-white/50 tw-rounded-[5px] tw-overflow-hidden">
          <img (click)="deleteBusinessBannerClicked(banner.id)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer" src="../../../assets/image-delete-icon.svg" />
          <img class="tw-w-full tw-h-full tw-object-cover" [src]="banner.bannerURL" />
        </div>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "social-media" | translate }}</p>
      <div class="tw-w-fit tw-min-w-72 tw-h-fit">
        <app-input [formGroup]="formGroup" formControlName="instagramUrl" [label]="'instagram-url' | translate" [widthLimited]="true"></app-input>
        <app-input [formGroup]="formGroup" formControlName="facebookUrl" [label]="'facebook-url' | translate" [widthLimited]="true"></app-input>
        <app-input [formGroup]="formGroup" formControlName="tiktokUrl" [label]="'tiktok-url' | translate" [widthLimited]="true"></app-input>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "pricing-plan" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-4 tw-mb-5">
        <p-dropdown
          class="tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="filteredPricingPlans"
          formControlName="plan"
          dataKey="id"
          [filter]="false"
          [showClear]="false"
          [placeholder]="'pricing-plan' | translate"
          (onChange)="setPlan($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.title | translate }} - {{ selectedOption.price | translate }}{{ selectedOption.priceTime | translate }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.title | translate }} - {{ item.price | translate }}{{ item.priceTime | translate }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div
        *ngIf="user.user.business.type == accountTypes.Merchant"
        class="tw-w-fit tw-max-w-72 tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-font-poppins tw-italic tw-text-xs tw-leading-5 tw-text-secondary/50"
      >
        <p>{{ "pricing-plan-description-1" | translate }}</p>
        <p>{{ "pricing-plan-description-2" | translate }}</p>
        <p>{{ "pricing-plan-description-3" | translate }}</p>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "language" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-4 tw-mb-5">
        <p-dropdown
          class="tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="languages"
          formControlName="language"
          dataKey="id"
          [filter]="false"
          [showClear]="false"
          [placeholder]="'language' | translate"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="fi fi-{{ selectedOption.flag }}"></span>
              <div>{{ selectedOption.title }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="fi fi-{{ item.flag }}"></span>
              <div>{{ item.title }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "currency" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-4 tw-mb-5">
        <p-dropdown
          class="tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="currencies"
          formControlName="currency"
          optionLabel="title"
          dataKey="id"
          [filter]="false"
          [showClear]="false"
          [placeholder]="'currency' | translate"
          (onChange)="setCurrency($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="fi fi-{{ selectedOption.flag }}"></span>
              <div>{{ selectedOption.title }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="fi fi-{{ item.flag }}"></span>
              <div>{{ item.title }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "payment-options" | translate }}</p>
      <div class="tw-w-fit tw-h-fit tw-flex tw-gap-4 tw-mb-5">
        <p-multiSelect
          class="tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="paymentOptions"
          formControlName="payment_options"
          [filter]="false"
          [showClear]="false"
          [placeholder]="'payment-options' | translate"
          optionLabel="label"
          optionValue="value"
        >
          <ng-template pTemplate="selectedItems" let-value>
            <div class="tw-flex tw-flex-wrap tw-gap-2">
              <div *ngFor="let option of value; let i = index" class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
                {{ option.label | translate }}{{ i < value.length - 1 ? ", " : "" }}
              </div>
            </div>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
              {{ option.label | translate }}
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>

    <div *ngIf="user.user.business.type == accountTypes.Merchant" class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "business-categories" | translate }}</p>
      <div class="tw-w-fit tw-h-fit tw-flex tw-gap-4 tw-mb-5">
        <p-multiSelect
          class="tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="categories"
          formControlName="categories"
          [filter]="true"
          [showClear]="false"
          [selectionLimit]="3"
          [placeholder]="'business-categories' | translate"
          optionLabel="name"
        >
          <ng-template pTemplate="selectedItems" let-value>
            <div class="tw-flex tw-flex-wrap tw-gap-2">
              <div *ngFor="let category of value; let i = index" class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
                {{ category.emoji }} {{ category.name | translate }}{{ i < value.length - 1 ? ", " : "" }}
              </div>
            </div>
          </ng-template>
          <ng-template let-category pTemplate="item">
            <div class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ category.emoji }} {{ category.name | translate }}</div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="tw-w-fit tw-max-w-72 tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-font-poppins tw-italic tw-text-xs tw-leading-5 tw-text-secondary/50">
        <p>{{ "business-categories-description" | translate }}</p>
      </div>
    </div>

    <div *ngIf="user.user.business.type == accountTypes.Delivery" class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "business-categories" | translate }}</p>

      <div class="tw-w-full tw-max-w-[500px] tw-h-fit tw-flex tw-gap-4 tw-mb-5">
        <p-multiSelect
          class="tw-w-full tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="businessCategories"
          [ngModel]="businessCategories"
          [ngModelOptions]="{ standalone: true }"
          [filter]="true"
          filterBy="name"
          [filterPlaceHolder]="'search-categories' | translate"
          [showClear]="false"
          display="chip"
          optionLabel="name"
          dataKey="id"
          [placeholder]="'business-categories' | translate"
        >
          <ng-template pTemplate="selectedItems" let-value>
            <div class="tw-flex tw-flex-wrap tw-gap-2">
              <span *ngFor="let category of value" class="tw-flex tw-items-center tw-gap-1 tw-bg-grey-100 tw-rounded-full tw-px-2 tw-py-1 tw-font-poppins tw-text-xs tw-text-secondary">
                {{ category.emoji }} {{ category.name | translate }}
                <img
                  *ngIf="category.deletable"
                  (click)="$event.stopPropagation(); deleteBusinessCategoryPopup(category.id)"
                  class="tw-w-3 tw-h-3 tw-object-contain tw-cursor-pointer tw-ml-1"
                  src="../../../assets/close-dark-icon.svg"
                />
              </span>
            </div>
          </ng-template>

          <ng-template let-category pTemplate="item">
            <div (click)="$event.stopPropagation()" class="tw-w-full tw-flex tw-items-center tw-gap-2">
              <span class="tw-flex-1 tw-font-poppins tw-text-sm tw-text-secondary">{{ category.emoji }} {{ category.name | translate }}</span>
              <img (click)="editBusinessCategoryClicked(category)" class="tw-w-4 tw-h-4 tw-object-contain tw-cursor-pointer" src="../../../assets/table-edit-icon.svg" />
              <img
                *ngIf="category.deletable"
                (click)="deleteBusinessCategoryPopup(category.id)"
                class="tw-w-4 tw-h-4 tw-object-contain tw-cursor-pointer"
                src="../../../assets/table-delete-icon.svg"
              />
            </div>
          </ng-template>

          <ng-template pTemplate="footer">
            <div (click)="addBusinessCategoryClicked()" class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-3 tw-border-t tw-border-grey-600 tw-cursor-pointer hover:tw-bg-grey-100">
              <span class="tw-font-poppins tw-text-base tw-text-secondary tw-leading-none">+</span>
              <span class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "add-category" | translate }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="tw-w-fit tw-max-w-72 tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-font-poppins tw-italic tw-text-xs tw-leading-5 tw-text-secondary/50">
        <p>{{ "manage-business-categories-description" | translate }}</p>
      </div>
    </div>

    <!-- New section for theme colors -->
    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "theme-colors" | translate }}</p>

      <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-4 tw-mb-5">
        <input type="color" formControlName="primary_color" class="tw-w-8 tw-h-8 tw-rounded-[5px] tw-border tw-border-grey-600" [style.background-color]="formGroup.get('primary_color').value" />
        <input type="color" formControlName="secondary_color" class="tw-w-8 tw-h-8 tw-rounded-[5px] tw-border tw-border-grey-600" [style.background-color]="formGroup.get('secondary_color').value" />
      </div>

      <div class="tw-w-fit tw-max-w-72 tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-font-poppins tw-italic tw-text-xs tw-leading-5 tw-text-secondary/50">
        <p>{{ "theme-colors-description" | translate }}</p>
      </div>
    </div>

    <div class="tw-w-full tw-h-fit tw-pb-5">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "actions" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-max-w-72 tw-flex tw-flex-col tw-gap-3">
        <app-button [text]="'reset-password' | translate" [fullWidth]="true" [onButtonClick]="resetPasswordClicked.bind(this)"></app-button>
        <app-button [text]="'delete-account' | translate" [fullWidth]="true" bgColor="warning" textColor="white" [onButtonClick]="deleteAccountClicked.bind(this)"></app-button>
      </div>
    </div>
  </form>

  <div class="tw-w-full tw-h-20"></div>
</div>
